import React, { useEffect, useMemo, useState } from 'react';
// import DataGrid from 'components/DataGrid';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  DatePicker,
  Form,
  notification,
  Row,
  Switch,
  Button,
  Card,
  Tabs,
  Col,
  Popconfirm,
} from 'antd';
import { FileAddFilled } from '@ant-design/icons';

import DF from 'DisplayFramework';
import { PAYListResponse, representPayments } from 'services/PaymentServices';
import SIStatusTag from 'pages/SupplierInvoice/SIStatusTag';
import moment from 'moment';
// import { dateToString } from 'utils/utils2';
import ParListSelect from 'components/ParListSelect';
import { toCurrency } from 'utils/utils';
import CIDetail from 'pages/ClientInvoice/CIDetail';
import SIDetail from 'pages/SupplierInvoice/SIDetail';
import ModalControllerNV from 'components/ModalControllerNV';
import ThirdPartyInput from 'components/ThirdPartyInput';
import PayementModal from '../PayementModal';
import FormInput from 'components/FormInput';
import GetLabel from 'DisplayFramework/components/GetLabel';
import PayRepresentmentListModal from './PayRepresentmentListModal';
import DeleteButton from 'components/DeleteButton';
import JobResult from 'pages/Accounting/Components/JobResult';
import { useForm } from 'antd/lib/form/Form';
import MgCompanyList from 'components/MgCompanyList';
import Title from 'components/Title';
import CIPayerSelect from 'pages/ClientInvoice/CIDetail/components/CIPayerSelect';
import UtinaCard from 'components/UtinaCard';

const PayListRepresentement = () => {
  const [searchs, setsearchs] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fildname = 'payRep';
  const [form] = useForm();

  const initialSearchValues = {
    cireference: '',
    ctreference: '',
    datemax: '',
    datemin: '',
    payallstat: '',
    paydocreference: '',
    paymode: 'DDEBIT',
    payreference: '',
    paystatus: 'REJECT',
    sireference: '',
    tpname: '',
    tpreference: '',
    paydirection: 'IN',
    currcode: '',
    paytype: '',
    flagFilters: false,
    duedate: moment(),
    tpbankaccount: '' as any,
    tpidend: 0,
    tpidstart: 0,
    mgid: 1,
  };

  const [searchParams, setSearchParams] = useState<any>(initialSearchValues);
  const { TabPane } = Tabs;

  const [exec, setExec] = useState<boolean>(false);
  const [duedate, setDuedate] = useState<any>();

  const [jobResponse, setJobResponse] = useState<any>();

  const [selectedFile, setSelectedFile] = useState<
    PAYListResponse[] | undefined
  >();
  useEffect(() => {
    form.setFieldsValue({mgid: Number(localStorage.getItem('mgid'))})

},[])
  const columnsList = useMemo<DataGridColDef<PAYListResponse>[]>(
    () => [
      {
        dataIndex: 'payreference',
        width: 80,
        fixed: 'left',
        filtrable: true,

        render: (value, record) => (
          <ModalControllerNV
            modal={({ setVisible, visible }) => (
              <PayementModal
                payid={record.payid}
                showAsModal
                hideButtons
                visible={visible}
                onCancel={() => setVisible(false)}
                onSuccess={() => setVisible(false)}
              />
            )}
            content={({ setVisible, visible }) => (
              <a onClick={() => setVisible(true)}>{value}</a>
            )}
          />
        ),
      },

      {
        dataIndex: 'tpname',
        width: 120,
      },
      {
        dataIndex: 'payamount',
        width: 120,
        render: (val, record) => toCurrency(val, record.currcode ?? localStorage.getItem('currcode') ?? ''),
      },

      {
        dataIndex: 'payremainingamount',

        width: 120,
        render: (val, record) => toCurrency(val, record.currcode ?? localStorage.getItem('currcode') ?? ''),
      },
      {
        comcode: 'InvoiceRef',
        dataIndex: 'cireference',
        width: 120,
        render: (value, record) => (
          <>
            {record.cireference && record.ciid && (
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <a onClick={() => setVisible(true)}>{record.cireference}</a>
                )}
                modal={({ setVisible, visible }) => (
                  <CIDetail
                    ciid={record.ciid}
                    onCancel={() => setVisible(false)}
                    showAsModal
                    visible={visible}
                  />
                )}
              />
            )}
            {record.sireference && record.siid && (
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <a onClick={() => setVisible(true)}>{record.sireference}</a>
                )}
                modal={({ setVisible, visible }) => (
                  <SIDetail
                    siid={record.siid}
                    onCancel={() => setVisible(false)}
                    showAsModal
                    visible={visible}
                  />
                )}
              />
            )}{' '}
            {(record.siid == null || record.siid === 0) &&
              (record.ciid == null || record.ciid === 0) &&
              value}
          </>
        ),
      },
      {
        dataIndex: 'ctreference',
        width: 120,
      },
      {
        dataIndex: 'paydocdate',
        comcode: 'paydocdate',
        width: 120,
        render: (e) => moment(e).format('YYYY-MM-DD'),
      },
      {
        dataIndex: 'paynbrepresentation',
        width: 120,
      },
      {
        comcode: 'paystatuslabel',
        dataIndex: 'paystatus',
        width: 120,
        render: (value, record) => (
          <SIStatusTag
            status={record.paystatus}
            statuslabel={record.statuslabel}
            key={record.payid}
          />
        ),
      },
      {
        dataIndex: 'action',
        width: 80,
        render: (value, record) => (
          <Popconfirm
            title="Are you sure to delete this function?"
            onConfirm={() => {
              setSelectedFile(
                selectedFile?.filter((file) => file.payid !== record.payid)
              );
            }}
            okText="Yes"
            cancelText="No"
          >
            <DeleteButton onlyIcon />
          </Popconfirm>
        ),
      },
    ],
    [searchParams, duedate, form, selectedFile]
  );

  const runPaymentrepresentement = (values: any) => {
    setIsLoading(true);
    representPayments({
      currcode: values?.currcode,
      duedate:
        moment(values?.duedate).format('YYYY-MM-DD') ??
        moment().format('YYYY-MM-DD'),
      flagFilters: searchParams?.flagFilters,
      mgid: values?.mgid ?? Number(localStorage.getItem('mgid')),
      payidList: !values.flagFilters
        ? selectedFile?.map((file) => file?.payid) ?? []
        : [],
      tpbankaccount: values?.tpbankaccount ?? 0,
      tpidend: values?.tpidend?.tpid ?? values?.tpidstart?.tpid ?? 0,
      tpidstart: values?.tpidstart?.tpid ?? 0,
    })
      .then((res) => {
        setJobResponse(res);
        setIsLoading(false);
        if (res.code === '200') {
          setExec(true);
          notification.success({
            message: res.message,
            description: res.description,
          });
        } else {
          notification.error({
            message: res.message,
            description: res.description,
          });
        }
      })
      .catch((err) => {
        setExec(true);
        setIsLoading(false);
      });
  };

  return (
    <DF.Provider pagcode="paymentrepresentement">
      <Form
        labelAlign="left"
        layout="vertical"
        style={{ marginTop: 20 }}
        form={form}
        onFinish={runPaymentrepresentement}
      >
        <Card title={<GetLabel label="paymentrepresentement" />} size="small">
          <Row gutter={14}>
            <Col span={4}>
              <FormInput name="filters">
                <Switch
                  checkedChildren={<GetLabel label="usePopulation"/>}
                  unCheckedChildren={<GetLabel label="useListe"/>}
                  onChange={(e) => {
                    setSelectedFile([]);
                    setJobResponse(undefined);
                    setSearchParams({
                      ...initialSearchValues,
                      flagFilters: e,
                    });
                    setExec(false);
                  }}
                  style={{ width: '100px !important' }}
                />
              </FormInput>
            </Col>

            {searchParams?.flagFilters ? (
              <Col span={20}>
                <Row gutter={14} justify="end">
                  <FormInput
                    col
                    md={8}
                    name="tpidstart"
                    rules={[{ required: true }]}
                  >
                    <ThirdPartyInput
                      onSelected={(tp) => {
                        form.setFieldsValue({ tpidend: tp });
                      }}
                    />
                  </FormInput>

                  <FormInput
                    col
                    md={8}
                    name="tpidend"
                    rules={[{ required: true }]}
                  >
                    <ThirdPartyInput
                      onSelected={(tp) => {
                        if (
                          form.getFieldValue('tpidstart')?.tpid !==
                          form.getFieldValue('tpidend')?.tpid
                        ) {
                          form.setFieldsValue({ tpbankaccount: '' as any });
                        }
                      }}
                    />
                  </FormInput>

                  <FormInput col md={8} name="currcode">
                    <ParListSelect parcode="CURRENCY" />
                  </FormInput>

                  <FormInput col md={8} name="mgid">
                    <MgCompanyList />
                  </FormInput>

                  <FormInput col md={8} name="duedate">
                    <DatePicker
                      placeholder="date min"
                      style={{ width: '100%' }}
                    />
                  </FormInput>
                  <Form.Item noStyle shouldUpdate>
                    {({ getFieldValue }) => (
                      <FormInput col md={8} name="tpbankaccount">
                        <CIPayerSelect
                          tpid={getFieldValue('tpidstart')?.tpid}
                          disabled={
                            getFieldValue('tpidstart')?.tpid !==
                            getFieldValue('tpidend')?.tpid
                          }
                        />
                      </FormInput>
                    )}
                  </Form.Item>
                </Row>
              </Col>
            ) : (
              <Col
                span={4}
                style={{
                  display: 'flex',
                  justifyItems: 'center',
                  alignItems: 'center',
                }}
              >
                <ModalControllerNV
                  modal={({ setVisible, visible }) => (
                    <PayRepresentmentListModal
                      onCancel={() => setVisible(false)}
                      visible={visible}
                      selectedRowKeys={selectedFile ?? []}
                      onSelect={(list: any) => {
                        setSelectedFile(list);
                        setVisible(false);
                      }}
                    />
                  )}
                  content={({ setVisible, visible }) => (
                    <Button
                      icon={<FileAddFilled />}
                      type="default"
                      style={{
                        width: '100%',
                        height: 40,
                        background: '#faad14',
                      }}
                      onClick={() => setVisible(true)}
                      disabled={exec}
                    >
                      <GetLabel label="SelectPayement" />
                    </Button>
                  )}
                />
              </Col>
            )}
          </Row>

          <Row gutter={16} hidden={searchParams.flagFilters}>
            <DataGrid
              rowKey="payid"
              dataSource={searchParams.flagFilters ? [] : selectedFile ?? []}
              titleComcode="paymentrepresentement"
              title=""
              columns={columnsList}
              hideTitle
              hideFilters
              size="middle"
              initialSearchValues={initialSearchValues}
              pagination={false}
              isLoading={isLoading}
            />
          </Row>

          <Col style={{ alignContent: 'center' }} xs={24}>
            {isLoading && (
              <Title level={3} type="danger" comcode="pleasewait" />
            )}
          </Col>
          <div style={{ textAlign: 'center',marginTop:30 }}>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              style={{ width: '30%' }}
            >
              execute
            </Button>
          </div>
          <UtinaCard comcode="result" level={5}>
            <JobResult jobResponse={jobResponse} entity="PAYMENT" />
          </UtinaCard>
        </Card>
      </Form>
    </DF.Provider>
  );
};

export default PayListRepresentement;
